<div class="sidenav-header">
  @if (!isCollapsed()) {
    <img class="max-h-[35px] mr-2.5" src="/assets/images/attendo_logo_white.svg" />
    <div class="flex flex-col overflow-hidden">
      <!-- <h3 class="overflow-hidden text-ellipsis font-light text-[1.2rem] leading-[1.4rem]">{{ (org$ | async)?.title }}</h3> -->
      <h4 class="overflow-hidden text-ellipsis font-semibold text-[0.9rem] leading-4 text-right">{{ unit?.title }}</h4>
    </div>
  } @else {
    <img class="max-h-[30px] m-0" src="/assets/images/attendo_logo_white.svg" />
  }
</div>
<nav class="flex-1 overflow-y-auto">
  <div *awIsGod>
    <a routerLink="/app/olympus" [routerLinkActive]="['active']" class="nav-item" [class.nav-item--collapsed]="isCollapsed()">
      <div class="nav-item__content" [class.nav-item__content--collapsed]="isCollapsed()">
        <mat-icon class="text-white/80">landscape</mat-icon>
        <span class="nav-item__text" [class.nav-item__text--collapsed]="isCollapsed()" translate>Olympus</span>
      </div>
    </a>
  </div>

  @for (item of items$ | async; track item) {
    <ng-container
      [ngTemplateOutlet]="item.children ? itemWithChildren : itemWithoutChildren"
      [ngTemplateOutletContext]="{ $implicit: item, level: 1 }"
    ></ng-container>
  }
</nav>
@if (!isCollapsed()) {
  <div class="flex items-center justify-between">
    <!-- <a class="p-1.5 text-[0.7em] text-white flex items-center" href="https://appbolaget.se" target="_blank">
      <img class="h-[25px]" src="assets/images/ab_logo--white.png" /> Appbolaget Sverige AB
    </a> -->
  </div>
}

<ng-template #itemWithChildren let-item let-isChild="isChild" let-level="level">
  @if (!isCollapsed()) {
    <mat-expansion-panel
      [class.mat-elevation-z0]="true"
      [expanded]="currentOpenItems.has(item)"
      [class.is-child]="isChild"
      [class.has-current-route]="currentOpenItems.has(item)"
    >
      <mat-expansion-panel-header>
        <div class="flex items-center gap-2" [style.paddingLeft]="level ? level * 16 + 'px' : '16px'">
          @if (item.icon) {
            <mat-icon class="text-white/80 mr-2">{{ item.icon }}</mat-icon>
          }
          <span class="select-none font-normal text-white/80">{{ item.title | translate }}</span>
        </div>
      </mat-expansion-panel-header>
      <div class="py-0">
        @for (item of item.children; track item) {
          <ng-container
            [ngTemplateOutlet]="item.children ? itemWithChildren : itemWithoutChildren"
            [ngTemplateOutletContext]="{ $implicit: item, isChild: true, level: level + 1 }"
          ></ng-container>
        }
      </div>
    </mat-expansion-panel>
  } @else {
    <!-- In collapsed mode, show icon that opens flyout -->
    <div
      class="nav-item nav-item--collapsed cursor-pointer"
      [class.active]="item.path | isActiveRoute: item.queryParams : router.url"
      (click)="showFlyout($event, item)"
    >
      <div class="nav-item__content nav-item__content--collapsed">
        @if (item.icon) {
          <mat-icon class="text-white/80 shrink-0">{{ item.icon }}</mat-icon>
        }
        <span class="nav-item__text nav-item__text--collapsed">{{ item.title | translate }}</span>
      </div>
    </div>
  }
</ng-template>

<ng-template #itemWithoutChildren let-item let-isChild="isChild" let-level="level">
  @if (item.path) {
    <a
      routerLink="/app/{{ item.path }}"
      [queryParams]="item.queryParams"
      class="nav-item"
      [class.nav-item--child]="isChild"
      [class.nav-item--collapsed]="isCollapsed()"
      [class.active]="item.path | isActiveRoute: item.queryParams : router.url"
      [style.paddingLeft]="!isCollapsed() ? level * 16 + 'px' : '0'"
      (click)="onNavItemClick()"
    >
      <div class="nav-item__content" [class.nav-item__content--collapsed]="isCollapsed()">
        @if (item.icon) {
          <mat-icon class="text-white/80 shrink-0">{{ item.icon }}</mat-icon>
        }
        <span class="nav-item__text" [class.nav-item__text--collapsed]="isCollapsed()" translate>{{ item.title }}</span>
        @if (item.badge && !isCollapsed()) {
          <div class="px-2.5 py-0.5 bg-primary rounded-full text-xs ml-2">{{ item.badge }}</div>
        }
      </div>
    </a>
  }

  @if (item.method) {
    <div
      (click)="navigationItemWithMethodClicked(item)"
      class="nav-item"
      [class.nav-item--child]="isChild"
      [class.nav-item--collapsed]="isCollapsed()"
      [style.paddingLeft]="!isCollapsed() ? level * 16 + 'px' : '0'"
    >
      <div class="nav-item__content" [class.nav-item__content--collapsed]="isCollapsed()">
        @if (item.icon) {
          <mat-icon class="text-white/80 shrink-0">{{ item.icon }}</mat-icon>
        }
        <span class="nav-item__text" [class.nav-item__text--collapsed]="isCollapsed()" translate>{{ item.title }}</span>
      </div>
    </div>
  }
</ng-template>

<!-- Flyout menu for collapsed mode -->
@if (isCollapsed() && activeFlyout(); as flyout) {
  <div class="flyout-backdrop" (click)="closeFlyout()"></div>
  <div class="flyout-menu" [style.top.px]="flyout.top">
    <div class="flyout-header">
      <span class="text-sm font-semibold">{{ flyout.item.title | translate }}</span>
    </div>
    @for (child of flyout.item.children; track child) {
      @if (child.path) {
        <a
          routerLink="/app/{{ child.path }}"
          [queryParams]="child.queryParams"
          class="flyout-item"
          [class.active]="child.path | isActiveRoute: child.queryParams : router.url"
          (click)="closeFlyout(); onNavItemClick()"
        >
          @if (child.icon) {
            <mat-icon class="text-white/80 shrink-0 mr-3">{{ child.icon }}</mat-icon>
          }
          <span class="flex-1 text-sm">{{ child.title | translate }}</span>
          @if (child.badge) {
            <div class="px-2.5 py-0.5 bg-primary rounded-full text-xs ml-2">{{ child.badge }}</div>
          }
        </a>
      }
      @if (child.method) {
        <div (click)="navigationItemWithMethodClicked(child); closeFlyout()" class="flyout-item cursor-pointer">
          @if (child.icon) {
            <mat-icon class="text-white/80 shrink-0 mr-3">{{ child.icon }}</mat-icon>
          }
          <span class="flex-1 text-sm">{{ child.title | translate }}</span>
        </div>
      }
    }
  </div>
}
